import { useDispatch } from 'react-redux';
import { loadAudienceToStore } from 'store/actions/audience';
import { loadAutomationsToStore } from 'store/actions/automation';
import { loadCampaignsToStore } from 'store/actions/campaign';
import { loadContactsToStore } from 'store/actions/contact';
import { loadEventsToStore } from 'store/actions/event';
import { loadFlagsToStore } from 'store/actions/flag';
import { loadNeuronsToStore } from 'store/actions/neuron';
import { loadMobilePushMessagesToStore } from 'store/actions/push/mobile';
import { loadRolesToStore } from 'store/actions/role';
import { loadSMSToStore } from 'store/actions/sms';
import { loadTransactionalsToStore } from 'store/actions/transactional';

export const useAppStore = () => {
  const dispatch = useDispatch();

  const clearResources = () => {
    dispatch(loadAudienceToStore([]));
    dispatch(loadAutomationsToStore([]));
    dispatch(loadCampaignsToStore([]));
    dispatch(loadContactsToStore([]));
    dispatch(loadEventsToStore([]));
    dispatch(loadFlagsToStore([]));
    dispatch(loadRolesToStore([]));
    dispatch(loadTransactionalsToStore([]));
    dispatch(loadSMSToStore([]));
    dispatch(loadMobilePushMessagesToStore([]));
    dispatch(loadNeuronsToStore([]));
  };

  return { clearResources };
};
